import { WheelConditionLevel } from '../../../constants/openMarketProduct/openMarketProduct';
import { MachineType } from '../../../interfaces/Brand.interfaces';
import { tractorImageType } from '../../../store/userSellTractorSurveySlice';
import { customAxios } from '../../common/customAxios';

export interface ITractorImage {
  type: tractorImageType;
  url: string;
}

interface postUsersSellTractorsParams {
  reqBody: {
    machineType: MachineType;
    brandId: string;
    userOwnTractorId: string | null;
    model: string;
    engineOutputInPs: number;
    rowConfig: string;
    manufacturedYear: number;
    operationTime: number;
    option: string | null;
    optionDetails: string[] | null;
    workingMachine: string | null;
    workingMachineDetails: string[] | null;
    hopeSellingPrice: number;
    tractorImages: ITractorImage[];
    location: string;
    directImportYn: boolean | null;
    priceNegotiationYn: boolean | null;
    frontTireCondition: WheelConditionLevel | null;
    rearTireCondition: WheelConditionLevel | null;
    leftTrackCondition: WheelConditionLevel | null;
    rightTrackCondition: WheelConditionLevel | null;
    frontWheelCondition: WheelConditionLevel | null;
    rearWheelCondition: WheelConditionLevel | null;
    needRepairParts: string[] | null;
    replacedParts: string[] | null;
    information: string;
  };
}

export const postUsersSellTractors = ({ reqBody }: postUsersSellTractorsParams): Promise<void> => {
  return customAxios.post('/user-sell-tractors', reqBody);
};
